import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../context/AuthContext";
import { userSelector } from "../../store/selectors";
import ProfileSidebar from "../../components/ProfileSidebar/ProfileSidebar";
import "./ActiveSessionsScreen.css";
import ProfileMainIcon from "../../assets/profile-main.svg";
import ProfileBillingIcon from "../../assets/profile-billing.svg";
import ProfileNotificationsIcon from "../../assets/profile-notifications.svg";
import ProfileSecurityIcon from "../../assets/profile-security.svg";
import desctopIcon from "../../assets/desctopIcon.svg";
import LogoutIcon from "../../assets/logout.svg";
import ProfileTeamIcon from "../../assets/users.svg";
import momentWithLocales from "moment/min/moment-with-locales";
import ProfileActiveSessionsIcon from "../../assets/profile-active-sessions.svg";
import Avatar from "../../components/Avatar/Avatar";
import AppLogo from "../../assets/AppLogoBlue.svg";
import toast from "react-hot-toast";
import { getSessionsList, resetAllSessions } from "../../store/usersSlice";
import NotificationsPopup from "../../components/NotificationsPopup/NotificationsPopup";
import ProfilePopup from "../../components/ProfilePopup/ProfilePopup";
import { ReactComponent as MenuIcon } from "../../assets/mobile/menu.svg";
import useIsMobile from "../../hooks/useIsMobile";

const ActiveSessionsScreen = () => {
  const user = useSelector(userSelector);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { logout } = useAuth();
  const [sessionsInfo, setSessionsInfo] = useState([]);
  const [showUserMenu, setShowUserMenu] = useState(false);
  const userName = user?.email;
  const isMobile = useIsMobile();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    document.title = "7cut • Активные сессии";
  }, []);

  useEffect(() => {
    dispatch(getSessionsList()).then((res) => {
      if (!res.error) {
        let newSessionsInfo = res.payload;
        let sortedSessionsInfo = newSessionsInfo.sort(() => {
          return -1;
        });
        setSessionsInfo(sortedSessionsInfo);
      }
    });
  }, []);

  const onClickLogoutAll = () => {
    dispatch(resetAllSessions()).then((res) => {
      dispatch(getSessionsList()).then((res) => {
        if (!res.error) {
          let newSessionsInfo = res.payload;
          let sortedSessionsInfo = newSessionsInfo.sort(() => {
            return -1;
          });
          setSessionsInfo(sortedSessionsInfo);
        }
      });
      toast.success("Успешно!");
    });
  };

  const formatDate = (dateString) => {
    const res = momentWithLocales(dateString)
      .locale("ru")
      .format("DD MMMM YYYY, HH:mm");
    return res;
  };

  const renderSessionInfo = (sessionInfo) => {
    return (
      <div className="active-sessions-session-info-container">
        <div className="active-sessions-session-info-logo-block">
          <img
            src={desctopIcon}
            alt="desctop"
            width={32}
            style={{ marginRight: 10 }}
            height={32}
          />
        </div>
        <div className="active-sessions-session-info-fields">
          <span className="active-sessions-session-info-title">
            {sessionInfo.ipAddress}
          </span>
          <span className="active-sessions-session-info-location">
            Последняя активность: {formatDate(sessionInfo.lastAccess)}
          </span>
        </div>
      </div>
    );
  };

  if (!user) return null;

  return (
    <div className={isMobile ? "App-mobile" : "App"}>
      {/* HEADER */}
      <div
        className={isMobile ? "mainScreenHeader-mobile" : "mainScreenHeader"}
      >
        <div className={isMobile ? "header-left-mobile" : "header-left"}>
          {isMobile && (
            <div
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              style={{ display: "flex", marginTop: 7 }}
            >
              <MenuIcon color="white" />
            </div>
          )}
          <div
            onClick={() => navigate("/home", { replace: true })}
            className={"mainScreen-logoBlock"}
            style={{ cursor: "pointer" }}
          >
            <img src={AppLogo} style={{ height: "100%" }} alt="logo" />
          </div>
        </div>
        <div className="header-actions">
          <NotificationsPopup />
          <ProfilePopup />
        </div>
      </div>
      {/* LAYOUT: sidebar + main content */}
      <div
        className="active-sessions-container"
        style={{ alignItems: "flex-start" }}
      >
        {/* SIDEBAR */}
        {((!isMobile || isMenuOpen) && (
          <ProfileSidebar activeTab="active-sessions" />
        )) ||
          null}
        {/* MAIN CONTENT */}
        <main
          className={
            isMobile ? "active-sessions-main-mobile" : "active-sessions-main"
          }
        >
          <h1 className="active-sessions-title">Активные сессии</h1>
          {(sessionsInfo.length && (
            <>
              <span className="active-sessions-current-device-label">
                Это устройство
              </span>
              {renderSessionInfo(sessionsInfo[0])}
              <span className="active-sessions-active-devices-label">
                Активные сеансы
              </span>
              {sessionsInfo.length > 1
                ? sessionsInfo
                    .slice(1)
                    .map((sessionInfo) => renderSessionInfo(sessionInfo))
                : sessionsInfo.map((sessionInfo) =>
                    renderSessionInfo(sessionInfo)
                  )}
              {}
              <div
                onClick={onClickLogoutAll}
                className="active-sessions-total-logout"
              >
                <img
                  src={LogoutIcon}
                  alt="notifications"
                  stroke="green"
                  width={24}
                  style={{ marginRight: 5 }}
                  height={24}
                />
                <span className="active-sessions-total-logout-text">
                  Выйти со всех устройств, кроме этого
                </span>
              </div>
            </>
          )) ||
            null}
        </main>
      </div>
    </div>
  );
};

export default ActiveSessionsScreen;
